import moment from 'moment';
import InviteNewCandidateService from "@/service/InviteNewCandidateService";
import SweetAlertService from "@/service/SweetAlertService";
import { CandidateInvited } from "@/model/CandidateInvited";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import verifyCandidateValidatonObj from "./VerifyCandidateValidaton.js";
var verifyCandidateDataValidatonObj = new verifyCandidateValidatonObj();
export default {
  name: "VerifyCandidate",
  components: {
    DatePicker
  },
  mounted() {
    this.scrollContent();
    verifyCandidateDataValidatonObj.verifyCandidateValidaton();
    this.validateToken();
    this.setMsg(this.Lang)
  },
  data: () => ({
    dictEnum: dictEnum,
    verifyCandidate: new CandidateInvited(),
    tab1: null,
    tabItems: [
      { tab1: 'One', content: 'Tab 1 Content' },
      { tab1: 'Two', content: 'Tab 2 Content' },
    ],
    Lang: "TC",
    LangList: [
      { id: 'EN', value: 'EngLish' },
      { id: 'SC', value: '简体中文' },
      { id: 'TC', value: '繁體中文' },
    ],
    date: new Date(),
    min: new Date(),
    max: new Date(),
    type: 'date',
    isLoaded: true,
    errors: [],
    dateOfBirth: "",
    mobile: "",
  }),
  computed: {
    t() {
      return t;
    },
    formattedDate() {
      return this.date &&
        moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
        ? moment(this.date).format('YYYY-MM-DD')
        : undefined;
    },
  },
  methods: {
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    async validateToken() {
      const obj = {
        token: this.$route.query.token,
        compCode: this.$route.query.compCode,
      };
      const response = await InviteNewCandidateService.validateToken(obj);
      if (response.data.IsSuccess) {

      } else {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.MSG_InvalidToken));
        window.location.href = "login/" + this.$router.query.compCode;
      }
    },
    async onValidateClick() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          var obj = {
            token: self.$route.query.token,
            dob: self.dateOfBirth,
            mobile: self.mobile,
            compCode: self.$route.query.compCode,
            lang: self.Lang
          }
          self.verifyCandidateData(obj);
        }
      });
    },
    async verifyCandidateData(obj) {
      var self = this;
      const response = await InviteNewCandidateService.verifyCandidate(obj);
      if (response.data.IsSuccess) {
        var candidateDetail = response.data.Data;
        if (candidateDetail.Status == "10") {
          SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_JobApplicationProcess));
        }
        else {
          await self.$store.dispatch({
            type: "AuthenticationStore/Login",
            payload: candidateDetail.authenticationResponse
          });
          await self.$store.dispatch({
            type: "AuthenticationStore/setCandidatelLang",
            payload: self.Lang
          });
          self.$router.push(`/jobapplication/${candidateDetail.CandID}`);
        }
      } else {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.MSG_InvalidToken));
      }
    },
    async setMsg(lang) {
      const res = await t.getMsg(lang);
      if (res.data.IsSuccess) {
        await this.$store.dispatch({
          type: `SysMsgStore/refreshStore`,
          payload: res.data.Data
        });
      } else {
        SweetAlertService.warning("Warn", res.data.Message);
      }
    },
    resetInvitationData: function () {
      var self = this;
      self.candidateInvited = new CandidateInvited();
      self.$validator.reset();
      self.vErrors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/VerifyCandidate/VerifyCandidate.js